// GAVION ai-email: assistant de rédaction IA (spéc. 2026-10-14-ai-email-assistant-design).
export const aiFr = {
  compose: {
    draft: "✨ Rédiger avec l'IA",
    regenerate: "Régénérer",
    drafting: "Rédaction…",
    instruction: "Consigne (facultatif)",
    instruction_placeholder: "relance pour la soumission, plus court…",
    replace_title: "Remplacer le texte actuel ?",
    replace_body: "Le brouillon IA remplace l'objet et le message.",
    rationale: "Pourquoi ce courriel : %{text}",
  },
  placeholder_left: "Remplacez « [à compléter] » avant d'envoyer.",
  errors: {
    unavailable:
      "Brouillon IA indisponible pour le moment. Réessaie plus tard.",
    cap: "Limite quotidienne de brouillons IA atteinte. Réessaie demain.",
    not_configured:
      "L'assistant IA n'est pas encore configuré (clé manquante).",
    unsupported_claim:
      "Brouillon refusé : contient « %{detail} » qui n'est pas dans l'historique.",
    unsupported_claim_generic:
      "Brouillon refusé : il contient un chiffre ou une promesse qui n'est pas dans l'historique.",
    forbidden: "Accès refusé.",
    not_found: "Compagnie introuvable.",
    not_pending:
      "Ce brouillon n'est plus disponible (remplacé, expiré ou déjà envoyé).",
  },
  dialer_toast: "Un brouillon de suivi sera prêt dans quelques minutes.",
  drafts: {
    title: "Brouillons",
    proposed: "Brouillon proposé",
    empty: "Aucun brouillon à approuver.",
    to: "À : %{email}",
    send: "Envoyer",
    edit: "Modifier",
    reject: "Rejeter",
    confirm_title: "Envoyer ce courriel ?",
    confirm_send: "Envoyer",
    cancel: "Annuler",
    sent: "Courriel envoyé.",
    rejected: "Brouillon rejeté.",
    reject_title: "Rejeter le brouillon",
    reject_reason: "Raison (facultatif)",
    reject_confirm: "Rejeter",
    reasons: {
      not_relevant: "Pas pertinent",
      wrong_tone: "Mauvais ton",
      factual_error: "Erreur factuelle",
      other: "Autre",
    },
    triggers: {
      after_call: "Après un appel",
      client_reply: "Réponse du client",
      after_demo: "Après la démo",
      stale_lead: "Compagnie sans nouvelles",
      on_demand: "Sur demande",
      follow_up: "Suivi IA",
    },
    rep_filter: "Représentant",
    mine: "Les miens",
    all_reps: "Tous",
    dashboard: "Brouillons à approuver (%{smart_count})",
    badge:
      "%{smart_count} brouillon à approuver |||| %{smart_count} brouillons à approuver",
    no_recipient: "Aucun destinataire : utilisez Modifier.",
    placeholder_block:
      "Ce brouillon contient « [à compléter] » : utilisez Modifier pour le compléter.",
  },
  // GAVION ai follow-up (spéc. 2026-10-20-ai-follow-up-agent-design)
  follow_up: {
    title: "Suivi IA",
    touch: "Touche %{position} de %{total}",
    touch_label: "Suivi — touche %{position} de %{total}",
    situations: {
      voicemail: "Message laissé",
      callback: "Rappel convenu",
      brochure: "Brochure envoyée",
      demo: "Démo",
      campaign: "Campagne courriel", // GAVION video-campaign
    },
    angles: {
      recap: "Récapitulatif",
      value: "Valeur",
      proof: "Preuve",
      question: "Question",
      pre_callback: "Avant le rappel",
      breakup: "Dernier message",
    },
    plan_status: { active: "En cours", done: "Terminé", stopped: "Arrêté" },
    touch_status: {
      planned: "Prévue",
      drafting: "En rédaction",
      proposed: "À approuver",
      sent: "Envoyée",
      skipped: "Sautée",
      cancelled: "Annulée",
    },
    stop_reasons: {
      replaced: "Remplacé par un nouveau suivi.",
      new_outcome: "Arrêté : un nouvel appel a eu un autre résultat.",
      reply: "Arrêté : le prospect a répondu.",
      unsubscribe: "Arrêté : le prospect s'est désabonné.",
      stop_request:
        "Arrêté : le prospect a demandé de ne plus recevoir de courriels.",
      bounce: "Arrêté : le courriel est revenu (adresse invalide).",
      complaint: "Arrêté : le prospect s'est plaint.",
      suppressed: "Arrêté : l'adresse est sur la liste de suppression.",
      lost: "Arrêté : l'opportunité est perdue.",
      won: "Arrêté : l'opportunité est gagnée.",
      customer: "Arrêté : la compagnie est devenue cliente.",
      do_not_call: "Arrêté : la compagnie est « Ne pas appeler ».",
      rep_cancel: "Annulé par le représentant.",
      merged: "Arrêté : la compagnie a été fusionnée.",
      ineligible:
        "Arrêté : la compagnie ne peut plus recevoir de courriel de suivi.",
      erased: "Arrêté : des données personnelles ont été effacées.",
      disabled: "Suivis IA désactivés.",
      // GAVION video-campaign: a campaign follow-up's own stops
      not_interested: "Arrêté : la compagnie est « Pas intéressé ».",
      demo_booked: "Arrêté : une démo est réservée.",
      in_pipeline: "Arrêté : la compagnie est en pipeline.",
      deal_created: "Arrêté : une opportunité a été créée.",
    },
    // why a touch was skipped (ai_follow_up_touches.error); any other code (an AI failure) → other
    touch_errors: {
      rejected: "Brouillon rejeté.",
      expired: "Brouillon expiré sans décision.",
      superseded: "Brouillon remplacé.",
      failed: "Brouillon non envoyé.",
      overtaken: "Dépassée par la touche suivante.",
      abandoned: "Rédaction interrompue.",
      draft_gone: "Le brouillon n'existe plus.",
      moved_past: "Sa nouvelle date était déjà passée.",
      cap_reached: "Plafond quotidien de brouillons IA atteint.",
      too_old: "Trop en retard : non rédigée.",
      other: "L'IA n'a pas pu rédiger cette touche.",
    },
    cancel_plan: "Annuler le suivi",
    cancel_confirm: "Confirmer l'annulation",
    cancel_keep: "Garder le suivi",
    cancelled: "Suivi annulé.",
    move: "Décaler",
    move_label: "Nouvelle date",
    move_save: "Enregistrer la date",
    cancel_edit: "Annuler",
    moved: "Touche décalée.",
    write_now: "Écrire maintenant",
    written_now: "La touche sera rédigée dans la prochaine minute.",
    dialer_toast:
      "Suivi IA planifié : la première touche arrivera dans Brouillons.",
    errors: {
      forbidden:
        "Seul le représentant du suivi ou un administrateur peut le modifier.",
      not_found: "Ce suivi n'existe plus.",
      not_active: "Ce suivi est déjà terminé ou arrêté.",
      not_planned: "Cette touche n'est plus prévue.",
      in_past: "Choisissez une date après aujourd'hui.",
      too_far: "Choisissez une date dans les 60 prochains jours.",
      not_business_day:
        "Choisissez un jour ouvrable (ni fin de semaine ni jour férié).",
      callback_day:
        "Un rappel est prévu ce jour-là : choisissez un autre jour.",
      out_of_order:
        "La date doit rester entre la touche précédente et la suivante.",
      busy: "Une touche est déjà en rédaction ou à approuver.",
      not_next: "Seule la prochaine touche peut être écrite maintenant.",
    },
    settings: {
      title: "Suivis IA",
      hint: "Après un appel « Message laissé », « Rappel convenu » ou « Brochure envoyée », ou des notes de démo Granola, l'IA planifie quelques courriels de suivi et rédige chacun une heure avant son envoi prévu (10 h, jours ouvrables). Le représentant approuve chaque courriel dans Brouillons.",
      enabled: "Suivis IA activés",
      enabled_hint:
        "Désactiver arrête tout de suite chaque suivi en cours (les brouillons de suivi en attente quittent Brouillons). Réactiver ne vaut que pour les nouveaux appels et démos.",
      demo: "Suivis après une démo",
      cadences:
        "Cadences (jours ouvrables après l'appel, séparés par des virgules)",
      cadence_hint:
        "De 3 à 5 touches (rappel convenu : de 1 à 5, plus une touche deux jours ouvrables avant un rappel à plus d'une semaine), chacune entre 1 et 60 jours, en ordre croissant.",
      models: "Modèle par usage",
      model_follow_up: "Suivis",
      model_drafts: "Brouillons (sur demande et brouillons proposés)",
      model_names: {
        "claude-sonnet-5-5": "Claude Sonnet 5.5",
        "claude-haiku-5-5": "Claude Haiku 5.5",
      },
      playbook: "Playbook de vente",
      playbook_hint:
        "Les règles et l'approche par situation que l'IA suit pour chaque courriel de suivi.",
      playbook_reset: "Rétablir le playbook par défaut",
      save: "Enregistrer les suivis",
      saved: "Paramètres des suivis enregistrés.",
      save_failed: "Enregistrement impossible. Réessayez.",
      errors: {
        playbook: "Entre 1 et 8 000 caractères.",
        cadence:
          "Des nombres entiers croissants entre 1 et 60, en nombre permis.",
      },
    },
  },
  // GAVION gavion-context: Paramètres → IA « Contexte Gavion » (admins)
  company_context: {
    settings: {
      title: "Contexte Gavion",
      hint: "Tout ce que l'IA sait de Gavion et de Gala (offre, forfaits, conditions, données, objections) : elle le lit avant chaque courriel (suivis et brouillons). Les représentants le lisent dans Formation → « Tout sur Gavion ».",
      context: "Contexte (Markdown)",
      count: "%{count} / %{max} caractères",
      reset: "Rétablir le contexte par défaut",
      facts: "Faits vérifiés",
      facts_hint:
        "Les seuls chiffres sur Gavion qu'un courriel de l'IA peut citer (avec l'offre du catalogue). Un chiffre absent d'ici est refusé.",
      fact_text: "Fait",
      fact_source: "Source",
      fact_add: "Ajouter un fait",
      fact_remove: "Retirer ce fait",
      facts_reset: "Rétablir les faits par défaut",
      facts_count: "%{count} / %{max} faits",
      save: "Enregistrer le contexte",
      saved: "Contexte Gavion enregistré.",
      save_failed: "Enregistrement impossible. Réessayez.",
      errors: {
        context: "Entre 1 et 30 000 caractères.",
        facts:
          "Au plus 150 faits, chacun avec un texte de 500 caractères au plus et une source de 300 caractères au plus.",
      },
    },
  },
  settings: {
    title: "IA",
    style: {
      title: "Mon style",
      hint: "L'assistant écrit comme vous : votre style est appris de vos courriels envoyés (Outlook) et mis à jour chaque semaine. Vous pouvez le corriger.",
      label: "Profil de style",
      default:
        "Pas encore de profil : le style Gavion par défaut s'applique (vouvoiement, court, chaleureux, une seule demande claire).",
      excerpts: "Extraits retenus",
      built:
        "Mis à jour le %{date} à partir de %{smart_count} courriel |||| Mis à jour le %{date} à partir de %{smart_count} courriels",
      save: "Enregistrer",
      saved: "Style enregistré.",
      rebuild: "Mettre à jour mon style",
      rebuilt:
        "Style mis à jour à partir de %{smart_count} courriel. |||| Style mis à jour à partir de %{smart_count} courriels.",
      too_few:
        "Moins de 5 courriels envoyés trouvés : le style Gavion par défaut s'applique.",
      empty: "Le profil ne peut pas être vide.",
    },
    admin: {
      title: "Assistant IA (administrateurs)",
      product_brief: "Description de Gavion utilisée par l'IA",
      brochure_url: "Lien de la brochure (https)",
      brochure_hint:
        "Utilisé seulement si le gabarit « Brochure » est absent ou n'a pas de lien.",
      daily_cap: "Brouillons IA par représentant et par jour",
      stale_days: "Compagnie « sans nouvelles » après (jours)",
      save: "Enregistrer",
      saved: "Paramètres IA enregistrés.",
      save_failed: "Enregistrement impossible. Réessayez.",
      errors: {
        productBrief: "Entre 1 et 2 000 caractères.",
        brochureUrl: "Une adresse https:// ou rien.",
        dailyCap: "Un nombre entier de 0 à 5 000.",
        staleDays: "Un nombre entier de 1 à 90.",
      },
    },
    auto_send: {
      title: "Envoi automatique",
      hint: "Bientôt : un déclencheur pourra envoyer sans confirmation. En attendant, voici la part des brouillons envoyés sans modification.",
      label: "Envoyer automatiquement — %{trigger}",
      soon: "Bientôt",
      metric:
        "%{rate} % envoyés sans modification (30 jours, %{smart_count} décidé) |||| %{rate} % envoyés sans modification (30 jours, %{smart_count} décidés)",
      error: "Métrique indisponible pour le moment.",
      no_data: "Pas encore de brouillon décidé (30 jours).",
    },
  },
};
